import * as React from "react";
import { cn } from "@/app/_utils/cn";

export interface LoadingDotsProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Diameter of each dot in px. */
  size?: number;
}

/** Three bouncing dots for inline/button-level loading. Inherits `currentColor`. */
export default function LoadingDots({
  size = 4,
  className,
  ...rest
}: LoadingDotsProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn("inline-flex items-center gap-[3px]", className)}
      {...rest}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="inline-block flex-none rounded-full bg-current animate-loading-dot"
          style={{
            width: size,
            height: size,
            animationDelay: `${i * 0.16}s`,
          }}
        />
      ))}
    </span>
  );
}
